import {
  LineupConfig as Config,
  filterPosition,
  getUpdateLineupsPayload,
  LineupModel,
  toSortedBySurname,
  updateLineups,
} from '@collector/desktop-feature-lineups'
import { Events } from '@collector/sportsapi-client'
import {
  ParticipantSubType,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { Event, Participant, SubParticipant } from '@collector/sportsapi-types'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'

import { LineupConfig } from '../../configuration'

export type PositionKey = 'startingLineup' | 'player' | 'coach' | 'willNotPlay'
export type BasketballLineupModel = LineupModel<PositionKey>
export type BasketballLineupConfig = Config<PositionKey>

export const lineupConfig: LineupConfig = {
  config: {
    addPlayer: {
      addAllTargets: ['player', 'coach'],
      addAllConfirmText:
        'Do you want to add all season squad as players and pick coach?',
    },
    positions: {
      startingLineup: {
        sectionLabel: '1st lineup',
        showShirtNr: true,
        showDeleteAll: true,
        maxCount: 5,
        maxCountReasonText: 'First lineup already has 5 players',
        buttonLabel: '1st',
        buttonClass:
          'hover:bg-neutral-9 hover:border-neutral-9 active:bg-neutral-9/50',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      player: {
        sectionLabel: 'Players',
        showShirtNr: true,
        showDeleteAll: true,
        buttonLabel: 'PLA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      coach: {
        sectionLabel: 'Coach',
        maxCount: 1,
        maxCountReasonText: 'Coach is already added',
        buttonLabel: 'COA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
      },
      willNotPlay: {
        deleteOnly: true,
        showDeleteAll: true,
        sectionLabel: 'Will not play',
        buttonLabel: '',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
      },
    },
  },
  createLineupModel(players: SubParticipant[]): BasketballLineupModel {
    return {
      startingLineup: filterPosition(
        players,
        SubParticipantPosition.StartingLineup,
      ),
      player: filterPosition(players, SubParticipantPosition.Player),
      coach: filterPosition(players, SubParticipantPosition.Coach),
      willNotPlay: filterPosition(players, SubParticipantPosition.WillNotPlay),
    }
  },
  toSortedLineupModel(lineup: LineupModel<PositionKey>): BasketballLineupModel {
    return {
      startingLineup: toSortedBySurname(lineup.startingLineup),
      player: toSortedBySurname(lineup.player),
      coach: [...lineup.coach],
      willNotPlay: [...lineup.willNotPlay],
    }
  },
  async updateLineups(
    eventId: Event['id'],
    participantId: Participant['id'],
    lineup: LineupModel<PositionKey>,
  ): Promise<void> {
    const squad: Events.SubParticipantsSave.SubParticipantsSavePostSquad[] = [
      ...getUpdateLineupsPayload(
        lineup.startingLineup,
        SubParticipantPosition.StartingLineup,
      ),
      ...getUpdateLineupsPayload(lineup.player, SubParticipantPosition.Player),
      ...getUpdateLineupsPayload(lineup.coach, SubParticipantPosition.Coach),
      ...getUpdateLineupsPayload(
        lineup.willNotPlay,
        SubParticipantPosition.WillNotPlay,
      ),
    ]

    await updateLineups(sportsApiClient, eventId, participantId, squad)
  },
}
